'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _TextField = require('@material-ui/core/TextField');
var _TextField2 = _interopRequireDefault(_TextField);
var _Button = require('@material-ui/core/Button');
var _Button2 = _interopRequireDefault(_Button);
var _colorManipulator = require('@material-ui/core/styles/colorManipulator');
var _InputAdornment = require('@material-ui/core/InputAdornment');
var _InputAdornment2 = _interopRequireDefault(_InputAdornment);
var _Person = require('@material-ui/icons/Person');
var _Person2 = _interopRequireDefault(_Person);
var _Email = require('@material-ui/icons/Email');
var _Email2 = _interopRequireDefault(_Email);
var _Edit = require('@material-ui/icons/Edit');
var _Edit2 = _interopRequireDefault(_Edit);
var _reactGoogleRecaptcha = require('react-google-recaptcha');
var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);
var _reactI18next = require('react-i18next');
var _urls = require('../../constants/urls');
var _urls2 = _interopRequireDefault(_urls);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var mainColor = '#333';
var buttonTextColor = '#FFF';
var styles = {
  ContactForm: {},
  inputRoot: {
    fontFamily: 'inherit',
    color: (0, _colorManipulator.darken)(mainColor, 0.3)
  },
  buttonRoot: {
    fontFamily: 'inherit',
    backgroundColor: (0, _colorManipulator.darken)(mainColor, 0.3),
    '&:hover': {
      backgroundColor: (0, _colorManipulator.darken)(mainColor, 0.6)
    },
    '&$disabled': {
      backgroundColor: (0, _colorManipulator.fade)(mainColor, 0.5)
    }
  },
  field: {},
  label: {
    color: mainColor,
    fontFamily: 'inherit',
    '&$focused': {
      color: (0, _colorManipulator.darken)(mainColor, 0.3)
    }
  },
  underline: {
    '&:before': {
      borderBottomColor: mainColor
    },
    '&:after': {
      borderBottomColor: (0, _colorManipulator.darken)(mainColor, 0.3)
    },
    '&:hover:not($disabled):not($focused):not($error):before': {
      borderBottomColor: mainColor
    }
  },
  disabled: {},
  focused: {},
  error: {
    color: 'red'
  },
  success: {
    color: '#3c763d'
  },
  recaptchaContainer: {
    margin: '1rem 0'
  }
};
var ContactForm = function (_Component) {
  _inherits(ContactForm, _Component);
  function ContactForm(props) {
    _classCallCheck(this, ContactForm);
    var _this = _possibleConstructorReturn(this, (ContactForm.__proto__ || Object.getPrototypeOf(ContactForm)).call(this, props));
    _this.handleChangeCaptcha = function (value) {
      _this.setState({
        recaptcha: value
      });
    };
    _this.handleChange = function (name) {
      return function (event) {
        _this.setState(_defineProperty({}, name, event.target.value));
      };
    };
    _this.submit = function () {
      var params = {
        full_name: _this.state.full_name,
        sender_email: _this.state.sender_email,
        destination_email: _this.props.otherProperties.destinationEmail,
        message: _this.state.message,
        'g-recaptcha-response': _this.state.recaptcha
      };
      var events = _this.props.entities;
      var eventUri = events[Object.keys(events)[0]].eventUri;
      _this.setState({
        processingRequest: true,
        successMessage: false
      }, function () {
        fetch(_urls2.default.getSubmitContactFormUrl(eventUri), {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(params)
        }).then(function (response) {
          if (response.status === 200) {
            _this.setState({
              processingRequest: false,
              successMessage: true,
              full_name: '',
              sender_email: '',
              message: '',
              errors: ''
            });
          }
          return response.json();
        }).then(function (data) {
          if (data.message) {
            _this.setState({
              processingRequest: false,
              errors: data.message
            });
          }
        });
      });
    };
    _this.state = {
      full_name: '',
      sender_email: '',
      message: '',
      processingRequest: false,
      errors: '',
      recaptcha: null,
      successMessage: false
    };
    return _this;
  }
  _createClass(ContactForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        classes = _props.classes,
        properties = _props.properties,
        children = _props.children,
        value = _props.value,
        t = _props.t;
      var _state = this.state,
        processingRequest = _state.processingRequest,
        full_name = _state.full_name,
        sender_email = _state.sender_email,
        message = _state.message,
        recaptcha = _state.recaptcha,
        errors = _state.errors,
        successMessage = _state.successMessage;
      var canSubmit = !!full_name && !!sender_email && !!message && !!recaptcha;
      var customInputProps = function customInputProps(adornment) {
        return {
          InputProps: {
            classes: {
              root: classes.inputRoot,
              input: classes.field,
              underline: classes.underline
            },
            startAdornment: _react2.default.createElement(_InputAdornment2.default, {
              position: 'start'
            }, adornment)
          },
          InputLabelProps: {
            shrink: true,
            FormLabelClasses: {
              root: classes.label,
              focused: classes.focused
            }
          }
        };
      };
      return _react2.default.createElement('div', {
        className: classes.ContactForm,
        style: properties
      }, _react2.default.createElement(_TextField2.default, _extends({
        label: t('contact_form.full_name'),
        value: full_name,
        onChange: this.handleChange('full_name'),
        margin: 'normal',
        fullWidth: true,
        required: true
      }, customInputProps(_react2.default.createElement(_Person2.default, null)))), _react2.default.createElement(_TextField2.default, _extends({
        label: t('contact_form.email'),
        value: sender_email,
        onChange: this.handleChange('sender_email'),
        margin: 'normal',
        fullWidth: true,
        required: true
      }, customInputProps(_react2.default.createElement(_Email2.default, null)))), _react2.default.createElement(_TextField2.default, _extends({
        label: t('contact_form.message'),
        value: message,
        onChange: this.handleChange('message'),
        margin: 'normal',
        fullWidth: true,
        required: true
      }, customInputProps(_react2.default.createElement(_Edit2.default, null)), {
        multiline: true,
        rows: '4'
      })), _react2.default.createElement('div', {
        className: classes.recaptchaContainer
      }, _react2.default.createElement(_reactGoogleRecaptcha2.default, {
        sitekey: '6LcA3CMTAAAAALzl31GBjiMFrMYUzUDyQ65yCpRC',
        onChange: this.handleChangeCaptcha,
        size: 'normal'
      })), errors && _react2.default.createElement('p', {
        className: classes.error
      }, errors), !errors && successMessage && _react2.default.createElement('p', {
        className: classes.success
      }, t('contact_form.success_message')), processingRequest ? _react2.default.createElement(_CircularProgress2.default, {
        size: 50
      }) : _react2.default.createElement(_Button2.default, {
        variant: 'contained',
        color: 'primary',
        onClick: this.submit,
        disabled: !canSubmit,
        classes: {
          root: classes.buttonRoot,
          disabled: classes.disabled
        }
      }, t('buttons.submit')));
    }
  }]);
  return ContactForm;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(ContactForm));